import { useField } from 'formik';
import { isEmpty } from 'lodash';
import { FC, useMemo } from 'react';

import { FormikOption } from 'src/general/components/forms/FormikInput/FormikInput.types';
import { InputSelectFormik } from 'src/general/components/forms/Input/InputSelectFormik';

import styles from './PlpFiltersRange.module.scss';

interface Props {
  minName: string;
  maxName: string;
  options: FormikOption[];
  minPlaceholder?: string;
  maxPlaceholder?: string;
}

export const PlpFiltersRange: FC<Props> = ({
  minName,
  maxName,
  options,
  minPlaceholder = 'From',
  maxPlaceholder = 'To',
}) => {
  const [minField] = useField(minName);
  const [maxField] = useField(maxName);
  const minOptions: FormikOption[] = useMemo(
    () =>
      // Cap the options to the max field value
      options.filter(
        (item) => isEmpty(maxField.value) || parseInt(item.value, 10) <= parseInt(maxField.value as string, 10),
      ),
    [options, maxField.value],
  );
  const maxOptions: FormikOption[] = useMemo(
    () =>
      // Cap the options to the min field value
      options.filter(
        (item) =>
          (isEmpty(minField.value) || parseInt(item.value, 10) >= parseInt(minField.value as string, 10)) &&
          (maxName === 'priceCashMax' ? parseInt(item.value, 10) > 15000 : true),
      ),
    [options, minField.value],
  );

  return (
    <div className={styles.root}>
      <InputSelectFormik
        name={minName}
        id={minName}
        options={minOptions}
        allowEmpty={minPlaceholder}
        size="small"
        className={styles.selectRange}
      />
      <InputSelectFormik
        name={maxName}
        id={maxName}
        options={maxOptions}
        allowEmpty={maxPlaceholder}
        size="small"
        className={styles.selectRange}
      />
    </div>
  );
};
